<template>
  <md-progress-spinner v-bind="$attrs" v-on="$listeners">
    <slot></slot>
  </md-progress-spinner>
</template>

<script>
export default {
  inheritAttrs: false,
}
</script>

